export default __webpack_public_path__ + "static/media/36.53337ddb.jpg";